import { ErrorScreen } from "@/components/ErrorScreen";
import { AuthLayout } from "@/components/layout/auth-layout";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/auth")({
  component: Layout,

  // Check if already authenticated and redirect if so
  beforeLoad: async ({ context }) => {
    // If already authenticated in context, redirect to home
    if (context.auth.user) {
      throw redirect({ to: "/" });
    }
  },

  errorComponent: ({ error }) => {
    return (
      <ErrorScreen
        error={error as Error}
        title="Error loading auth"
        message="An unknown error occurred while loading the authentication page."
      />
    );
  },
});

function Layout() {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
}
